import { Button } from '@verlo/shared/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '@verlo/shared/components/ui/dialog';
import { Wine, Beer } from 'lucide-react';

const SizeSelectDialog = ({
  open,
  onOpenChange,
  item,
  onSelectSize,
  formatCurrency,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="confirm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {item?.category?.includes('lager') ? <Beer size={20} /> : <Wine size={20} />}
            {item?.name}
          </DialogTitle>
          <DialogDescription>Select a size</DialogDescription>
        </DialogHeader>
        
        {item && (
          <div className="space-y-2 py-2">
            {item.size_options?.map((sizeOpt, idx) => {
              // Support both price_modifier (relative) and price (absolute) formats
              const finalPrice = sizeOpt.price !== undefined ? sizeOpt.price : item.price + (sizeOpt.price_modifier || 0);
              return (
                <Button
                  key={idx}
                  variant="outline"
                  className="w-full h-14 justify-between text-left hover:bg-verlo/5 hover:border-verlo"
                  onClick={() => onSelectSize(item, { ...sizeOpt, price: finalPrice })}
                  data-testid={`size-option-${sizeOpt.name.toLowerCase().replace(/\s/g, '-')}`}
                >
                  <span className="font-medium">{sizeOpt.name}</span>
                  <span className="font-bold text-verlo">
                    {formatCurrency(finalPrice)}
                  </span>
                </Button>
              );
            })}
          </div>
        )}
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SizeSelectDialog;
